// src/sites/Tos.jsx
import React from "react";
import { useI18n } from "../I18nProvider";
import "./styles.css";

export default function Tos() {
  const { t } = useI18n();

  return (
    <>

      <br></br><br></br><br></br>
      <section id="tos" className="services">
        <div className="container">
          <h2>{t("tos.title")}</h2>

          <div
            className="privacy-content"
            dangerouslySetInnerHTML={{ __html: t("tos.html") }}
          />
        </div>
      </section>
      <br></br><br></br>
    </>
  );
}
